// MFA API Service
import axiosInstance from './index';

const mfaService = {
  getStatus: async () => {
    const response = await axiosInstance.get('/v1/admin/mfa/status');
    return response.data;
  },

  startEnrollment: async () => {
    const response = await axiosInstance.post('/v1/admin/mfa/enroll/start');
    return response.data;
  },

  completeEnrollment: async (credential, deviceName = null) => {
    const response = await axiosInstance.post('/v1/admin/mfa/enroll/complete', {
      credential,
      device_name: deviceName
    });
    return response.data;
  },

  verifyMFA: async (tempSessionId, credential) => {
    const response = await axiosInstance.post('/v1/admin/mfa/verify', {
      temp_session_id: tempSessionId,
      credential
    });
    return response.data;
  },

  resetOwnMFA: async (password) => {
    const response = await axiosInstance.post('/v1/admin/mfa/reset', {
      password
    });
    return response.data;
  },

  toggleMFAForAdmin: async (adminId, enabled, enforcement) => {
    const body = { enabled };
    if (enforcement) {
      body.enforcement = enforcement;
    }
    const response = await axiosInstance.post(`/v1/admin/admins/${adminId}/mfa/toggle_enabled`, body);
    return response.data;
  },

  resetAdminMFA: async (adminId) => {
    const response = await axiosInstance.post(`/v1/admin/admins/${adminId}/mfa/reset`);
    return response.data;
  },

  bulkToggleMFA: async (enabled, enforcement) => {
    const body = {
      mfa: {
        enabled,
        ...(enforcement ? { enforcement } : {}),
      },
    };
    const response = await axiosInstance.post('/v1/admin/admins/mfa/bulk_toggle_enabled', body);
    return response.data;
  },

  optionalSkip: async () => {
    const response = await axiosInstance.post('/v1/admin/mfa/optional_skip');
    return response.data;
  }
};

export default mfaService;
